var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacehr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34104 0.311794C8.10216 -0.103931 11.8978 -0.103931 15.6589 0.311794C17.7413 0.544806 19.4214 2.18196 19.6657 4.26814C20.1114 8.07643 20.1114 11.9236 19.6657 15.7319C19.4214 17.818 17.7413 19.4552 15.6589 19.6882C11.8978 20.1039 8.10216 20.1039 4.34104 19.6882C2.2586 19.4552 0.578547 17.818 0.334198 15.7319C-0.111399 11.924 -0.111399 8.07724 0.334198 4.26936C0.457792 3.25584 0.92061 2.31369 1.64764 1.5956C2.37468 0.877508 3.32332 0.425562 4.33982 0.313007M9.99997 3.94047C10.2418 3.94047 10.4737 4.03637 10.6447 4.20706C10.8157 4.37776 10.9117 4.60927 10.9117 4.85067V9.0898H15.158C15.3999 9.0898 15.6318 9.18569 15.8027 9.35639C15.9737 9.52708 16.0698 9.7586 16.0698 10C16.0698 10.2414 15.9737 10.4729 15.8027 10.6436C15.6318 10.8143 15.3999 10.9102 15.158 10.9102H10.9117V15.1493C10.9117 15.3907 10.8157 15.6222 10.6447 15.7929C10.4737 15.9636 10.2418 16.0595 9.99997 16.0595C9.75815 16.0595 9.52625 15.9636 9.35526 15.7929C9.18428 15.6222 9.08822 15.3907 9.08822 15.1493V10.9102H4.84189C4.60008 10.9102 4.36817 10.8143 4.19719 10.6436C4.0262 10.4729 3.93014 10.2414 3.93014 10C3.93014 9.7586 4.0262 9.52708 4.19719 9.35639C4.36817 9.18569 4.60008 9.0898 4.84189 9.0898H9.08822V4.85067C9.08822 4.60927 9.18428 4.37776 9.35526 4.20706C9.52625 4.03637 9.75815 3.94047 9.99997 3.94047Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacehr);
export default __webpack_public_path__ + "static/media/teacehr_+.6e835aefd0c9f96708429fe20e371267.svg";
export { ForwardRef as ReactComponent };